import React from 'react';
import styled from 'styled-components';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import breakpoint from 'styled-components-breakpoint';
import GraphBackground from './assets/graph-background.svg';

const Wrapper = styled.div`
  width: 100%;
  height: 350px;
  position: relative;
  overflow: hidden;

  ${breakpoint('tablet')`
    height: 480px;
  `};
`;

const TextWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  padding: 20px;
  z-index: -1;

  &::before {
    content: '';
    width: 962.49px;
    height: 298.79px;
    background-image: url(${GraphBackground});
    background-repeat: no-repeat;
    background-position: 61% 81%;
    position: absolute;
    max-width: 100vw;
    z-index: -2;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -28%) scale(0.8);
  }

  ${breakpoint('tablet')`
    transform: translate(-70%,-59%);
    padding: 0;

    &::before {
      transform: translate(0) scale(1);
      top: 12px;
      left: -2px;
      margin-right: 0;
    }
  `};

  ${breakpoint('desktop')`
    transform: translate(-86%,-59%); 
  `};
`;

const Title = styled.h1`
  font-weight: 700;
  font-size: 32px;
  line-height: 50px;
  color: #333333;
  margin-bottom: 5px;

  ${breakpoint('tablet')`
    font-size: 58px;
    line-height: 74px;
    letter-spacing: 1.5px;
    margin-bottom: 15px;
  `};

  & > span > span {
    color: #2756f5;
    position: relative;
    letter-spacing: 0.5px;

    &:after {
      content: '';
      position: absolute;
      width: 74%;
      height: 20px;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 558 42'%3E%3Cpath stroke='%232756F5' stroke-linecap='round' stroke-width='10' d='M5 25C73.5 14 337 2.5 421.5 6c188.3 7.8 135 22 77.5 19-96-5-269.5 0-408 12'/%3E%3C/svg%3E");
      background-size: 100%;
      background-repeat: no-repeat;
      bottom: -16px;
      left: 35px;
    }
  }
`;

const Subtitle = styled.p`
  font-weight: 400;
  font-size: 18px;
  line-height: 23px;
  color: #333333;
  max-width: 400px;

  ${breakpoint('tablet')`
    font-size: 25px;
    line-height: 32px;
    letter-spacing: 0.3px;
  `};
`;

const Heading = () => {
  return (
    <Wrapper>
      <TextWrapper>
        <Title>
          <FormattedHTMLMessage
            id="homeredesign.headingblock.title"
            defaultMessage="999 для <span>бизнеса.</span>"
          />
        </Title>
        <Subtitle>
          <FormattedMessage
            id="homeredesign.headingblock.subtitle"
            defaultMessage="Здесь есть все, чтобы начать продавать больше"
          />
        </Subtitle>
      </TextWrapper>
    </Wrapper>
  );
};

export default Heading;
